import { useContext } from 'react';
import { ContainerContext, EditorBaseContext } from './provider';

export const useEditorContext = <T = EditorBaseContext>(): T => {
    const ctx = useContext(ContainerContext);
    if (!ctx) throw new Error('Must use ContainerContext first');
    return ctx as T;
};
